export enum MaintenanceNavigationType {
  History = "history",
  Open = "open",
  Upcoming = "upcoming",
}

export enum MaintenanceUpcomingType {
  Calendar = "calendar",
  Table = "table",
}
